//@flow
//ok is this working?

export const PRIMARY_KEY = "pk";
export const OPEN_INPUT = "oi";
export const SELECT_OPTION = "so";
export const BOOLEAN = "bo";
export const CODEBOOK = "cb";
export const CUSTOM = "cu";
